var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "toast" } },
    [
      _c("transition", [
        _vm.show
          ? _c(
              "div",
              {
                staticClass: "alert",
                class: {
                  "alert-success": !_vm.error,
                  "alert-danger": _vm.error
                },
                attrs: { role: "alert" }
              },
              [
                _vm._v("\n        " + _vm._s(_vm.message) + "\n        "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light btn-sm",
                    staticStyle: {
                      "border-radius": "50px",
                      position: "absolute",
                      top: "-15px",
                      right: "0"
                    },
                    attrs: { type: "button" },
                    on: { click: _vm.close }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-times",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34c8a83e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c8a83e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/Toast.vue
// module id = 348
// module chunks = 0